module.exports = __webpack_public_path__ + "img/qus1.67e106ca.svg";